const MAX_MENU_NAME_LENGTH = 30;

export const truncateMenuName = (name?: string | null): string => {
  if (!name) return '';
  if (name.length <= MAX_MENU_NAME_LENGTH) return name;

  const lastSpace = name.lastIndexOf(' ', MAX_MENU_NAME_LENGTH - 1);
  const cutoff = lastSpace > 0 ? lastSpace : MAX_MENU_NAME_LENGTH - 1;
  return `${name.slice(0, cutoff)}…`;
};
